import { gql } from "graphql-request";

export function categoriesQuery() {
  return gql`
    query categories {
      categories {
        id
        name
        slug
      }
    }
  `;
}
